
import { Modal } from '@mui/material'
import { VerifySingleSignOn } from 'api/authentication'
import Cookies from 'js-cookie'
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Wrapper from 'ui-components/Wrapper'
import { checkForDomain, findFirstTrueValue, getFirstRoute, setTokenForAuthorization } from 'utilities/index'

const SingleSignOn = () => {
    const { mutateAsync: verifySSO, isLoading } = VerifySingleSignOn()
    const [params] = useSearchParams();
    const navigate = useNavigate()
    const currentLOcation = window.location.pathname;
    React.useEffect(() => {
        // mutateAsync
        if (params.get("access-token") && params.get("access-token")?.length > 0) {
            const cookies = document.cookie.split(";");
            cookies.forEach(cookie => {
                const eqPos = cookie.indexOf("=");
                const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
            });
            verifySSO({ "token": params.get("access-token") }).then((SuccessResponse) => {

                const response = SuccessResponse?.data?.data;
                const currentIP = window.location.host;
                if (currentIP?.includes("localhost")) {
                    if (response?.collaborator_data?.connected_id) {
                        Cookies.set("X-ST-ID", response?.collaborator_data?.connected_id);
                    }
                    params.get("access-token") && setTokenForAuthorization(params.get("access-token"));
                }
                // Session to be same for current users:
                if (response?.collaborator_data?.connected_id) {
                    Cookies.set("X-ST-ID", response?.collaborator_data?.connected_id, { domain: checkForDomain() });
                }
                params.get("access-token") && setTokenForAuthorization(params.get("access-token"), checkForDomain());
                // if (response?.collaborator_data?.connected_id) {
                //     Cookies.set("X-ST-ID", response?.collaborator_data?.connected_id, { domain: checkForDomain() });
                // }
                Cookies.set("step", response?.step)
                Cookies.set("is_profile_complete", true, {domain: checkForDomain()});
                if (params.get("redirect")) {
                    const redirect = params.get("redirect");
                    if (redirect === "upgrade") {
                        Cookies.remove("IS_MIXPANEL_DISABLED");
                        navigate("/?upgrade=true", { replace: true })
                    }
                    else {
                        Cookies.remove("IS_MIXPANEL_DISABLED");
                        navigate("/", { replace: true })
                    }
                }
                else {
                    Cookies.set("IS_MIXPANEL_DISABLED", true);
                    navigate("/", { replace: true })
                }
                // Cookies.set("is_profile_complete", response?.is_profile_completed || false);
                // navigate(response?.is_profile_completed ? "/" : "/onboarding", { replace: true });
            })
        }
    }, [params.get("access-token")])
    // console.log(params.get("access-token"), "ttttt")

    return (
        <Modal open={isLoading}>
            <Wrapper className="skeleton" style={{
                display: 'grid', height: '100dvh',
                width: "100vw",
                placeItems: 'center'
            }}>
                {/* <CircularProgress sx={{ color: theme?.palette.customColors.b300 }} /> */}
            </Wrapper>
        </Modal>
    )
}

export default SingleSignOn